module.exports = __webpack_public_path__ + "static/img-login-e011f8817dd72a178da2096a89739737.svg";